import { Container, PageFade, Reveal } from "../components/site/Motion";
import { PageHeader } from "../components/site/Sections";
import { ForfaitMiniCard } from "../components/site/Forfait";
import { useForfaits } from "../lib/useForfaits";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function Forfaits() {
  const forfaits = useForfaits() || [];
  return (
    <PageFade>
      <PageHeader eyebrow="Nos solutions" title="Quatre forfaits," accent="une approche adaptée.">
        <p className="max-w-2xl text-lg text-[#242020]/80">Découvrez les forfaits STRUKTIV et leurs composantes. Pour obtenir une suggestion selon votre réalité, répondez au questionnaire.</p>
        <Link to="/secteurs" className="btn-primary" data-testid="forfaits-questionnaire-cta">DÉCOUVRIR MON FORFAIT <ArrowRight className="h-4 w-4" /></Link>
      </PageHeader>
      <Container className="py-16">
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4" data-testid="forfaits-grid">
          {forfaits.map((f, i) => <Reveal key={f.slug} delay={i * 0.08}><ForfaitMiniCard f={f} featured={i === 3} /></Reveal>)}
        </div>
      </Container>
    </PageFade>
  );
}
